module.exports = __webpack_public_path__ + "img/survey_banner_app.3d8df6f3.png";